import { RadioGroup } from "@mui/material";
import { RadioBtn } from "Components/RadioBtn";
import React from "react";

interface ObserverIdentityProps {
  showObserverCode: boolean;
  setFieldValue: (field: string, value: boolean) => void;
}

export const ObserverIdentity: React.FC<ObserverIdentityProps> = ({
  showObserverCode,
  setFieldValue,
}) => {
  return (
    <div className="w-full pt-3">
      <p className="text-base font-medium text-secondaryMid dark:text-textMain">
        Observer identity in output
      </p>
      <p
        id="observer-identity-help"
        className="mt-1 text-sm leading-5 text-secondaryMidLight dark:text-caption"
      >
        Anonymized output replaces real names with stable observer codes. Admins
        can still link a code to a user internally. This is recommended when
        sharing data where personal identities should be protected.
      </p>

      <RadioGroup
        aria-describedby="observer-identity-help"
        aria-label="Observer identity in output"
        className="mt-1"
        value={showObserverCode ? "anonymized" : "fullNames"}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setFieldValue(
            "showObserverCode",
            event.target.value === "anonymized",
          );
        }}
      >
        <RadioBtn
          value="fullNames"
          className="h-9"
          sx={{ padding: "6px" }}
          labelContent={
            <span className="ml-1 text-sm text-textMid dark:text-textMain">
              Show full names
            </span>
          }
        />
        <RadioBtn
          value="anonymized"
          className="h-9"
          sx={{ padding: "6px" }}
          labelContent={
            <span className="ml-1 text-sm text-textMid dark:text-textMain">
              Show anonymized observer codes (recommended for sharing)
            </span>
          }
        />
      </RadioGroup>
    </div>
  );
};
